import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { Switch, Route, Link, Redirect, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import { useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import CssBaseline from '@material-ui/core/CssBaseline';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Collapse from '@material-ui/core/Collapse';
import Popover from '@material-ui/core/Popover';
import { Button } from '@material-ui/core';
import EMInvoice from '../../modules/EmInvoice';
import ViewInvoices from '../../modules/EmInvoice/viewInvoice';

import {
    faHandshake,
    faLandmark,
    faUserPlus,
    faPlus,
    faWrench,
    faFileAlt,
    faWallet,
    faMale,
    faUser,
    faBell,
    faAngleDown,
    faSignOutAlt,
    faLockOpen,
    faHandHolding,
} from '@fortawesome/free-solid-svg-icons';
import { useIdleTimer } from 'react-idle-timer';

import useStyles from './menubarStyle';
import logo from '../../assets/Login_logo.png';
import ItechView from '../../modules/itec/view/index';
import Itec from '../../modules/itec/create';
import ClientIndividualView from '../../modules/ultimate/view/individual';
import ClientCorporateView from '../../modules/ultimate/view/corporate';
import ClientColleagueView from '../../modules/ultimate/view/colleague';
import ClientIndividualCreate from '../../modules/ultimate/create/individual';
import ClientCorporateCreate from '../../modules/ultimate/create/corporate';
import ClientColleagueCreate from '../../modules/ultimate/create/colleague';
import IMCView from '../../modules/imc/view/index';
import Intermediary from '../../modules/imc/create';
import CoreView from '../../modules/core/view/index';
import Core from '../../modules/core/create/index';
import ManagePerm from '../../modules/manageperm/view/index';
import SuperAdminRoleMatrix from '../../modules/manageperm/superAdminRoleMatrix/index';
import IndividualRoleMatrix from '../../modules/manageperm/individualRoleMatrix/index';
import InvoicePayment from '../../modules/invoices/payment';
import AdminPayments from '../../modules/payments/view/adminpayments';
import AdminPaymentHistory from '../../modules/payments/view/adminpaymenthistory';
import SuperAdminPayments from '../../modules/payments/view/superadminpayment';
import IndividualPaymentHistory from '../../modules/payments/view/individualpaymenthistory';
import CorporatePaymmentHistory from '../../modules/payments/view/corporatepaymenthistory';
import Dashboard from '../../modules/dashboard/view/index';
import ResetPassword from '../../modules/users/resetpassword/index';
import UpdateImc from '../../modules/imc/edit';
import UpdateItec from '../../modules/itec/edit';
import UpdateIndividual from '../../modules/ultimate/edit/UpdateIndividual';
import UpdateCorporate from '../../modules/ultimate/edit/UpdateCorporate';
import UpdateColleague from '../../modules/ultimate/edit/UpdateColleague';
import BankClients from '../../modules/bankdetails/SuperAdmin/index';
import AdminBankDetails from '../../modules/bankdetails/admin/index';
import EditBankDetails from '../../modules/bankdetails/SuperAdmin/edit';
import AdminEditBankDetails from '../../modules/bankdetails/admin/edit';
import Services from '../../modules/services/create';
import OpenService from '../../modules/services/view/OpenService';
import ClosedService from '../../modules/services/view/ClosedService';
import UpdateServices from '../../modules/services/edit';

import UpdateCore from '../../modules/core/edit';
import ImcInvoices from '../../modules/invoices/SuperAdmin/view/index';
import TaxInvoice from '../../modules/invoices/TaxInvoice/taxinvoice';
import TaxInvoiceInd from '../../modules/invoices/TaxInvoice/taxinvoiceInd';
import UpdateInvoice from '../../modules/invoices/SuperAdmin/edit';
import ViewGeneratedInvoice from '../../modules/invoices/SuperAdmin/create';
import AdminIndInvoice from '../../modules/invoices/Admin/view/serviceInvoice';
import UpdateIndInvoice from '../../modules/invoices/Admin/edit';
import ScrollToTop from '../ScrollBar/ScrollToTop';
import AdminCorpInvoice from '../../modules/invoices/Admin/view/corporate';
import ItecInvoice from '../../modules/invoices/Itec';
import UltimateInvoiceView from '../../modules/invoices/Ultimate';
import UltimateInvoice from '../../modules/invoices/ultimateClient';
import CheckListGenerator from '../../modules/checkListGenerator';
import CoreEMDashboard from '../../modules/newEMDashboard';
import ClientCheckListGenetator from '../../modules/checkListGenerator/clientchecklist/generalinfo/generalinfo';
import ClientBankDetailsGenerator from '../../modules/checkListGenerator/clientchecklist/bankdetails/bankdetails';
import ClientIncomeTaxPassword from '../../modules/checkListGenerator/clientchecklist/incometaxpassword/incometaxpassword';
import ClientTravelOutsideIndia from '../../modules/checkListGenerator/clientchecklist/traveloutsideindia/traveloutsideindia';
import DirectorInCompany from '../../modules/checkListGenerator/clientchecklist/directorincompany/directorincompany';
import AddAdditional from '../../modules/checkListGenerator/addAdditional/index';
import ClientTotalIncome from '../../modules/checkListGenerator/clientchecklist/totalincome/totalincome';
import DifferentSource from '../../modules/checkListGenerator/clientchecklist/differentSource/differentSource';
import ClientForeignAssets from '../../modules/checkListGenerator/clientchecklist/foreignassets/index';
import ClientChecklistHome from '../../modules/checkListGenerator/clientchecklist/home';
import DetailAnalysis from '../../modules/coredashboard/dashboard';
import DetailAnalysisCore from '../../modules/core/DetailAnalysisCore';
import ItecOpenService from '../../modules/itecopenservice/tasks/itectask';
import ItechCheckList from '../../modules/checkListGenerator/itechChecklist';
import ItechBankDetails from '../itechAccordin/itechBankAccDetails';
import ItecOpenServiceAM from '../../modules/itecopenservice/tasks/itectaskAM';
import IncorporationFlow from '../../modules/incorporationFlow';
import CrcCheckList from '../../modules/checkListGenerator/crcChecklist';
import ClientAddAdditional from '../../modules/checkListGenerator/clientchecklist/clientAddAdditional';
import IMCDraftDocument from '../../modules/draftDocument/imcDraftDocument';
import ClientDraftDocument from '../../modules/draftDocument/clientDraftDocument';
import UltimateOpenService from '../../modules/ultimateopenservice/ultimateopenservice';
import IMCFinalDocument from '../../modules/finalDocument/imcFinalDocument';
import IMCFinalDocApproval from '../../modules/finalDocument/imcFinalDocClientApproval';
import ClientFinalDocument from '../../modules/finalDocument/clientFinalDocument';
import ClientFinalDocApproval from '../../modules/finalDocument/clientFinalDocApproval';
import IMCReports from '../../modules/imcReports';
import RequestInvoice from '../../modules/requestInvoice';
import ItecDetailAnalysisCRC from '../../modules/itecdashboardCRC/dashboard';
import ItecDetailAnalysisAM from '../../modules/itecdashboardAM/dashboard';
import Notification from './notification';
import Rename from '../../modules/renameTeam';
import PendingInvoices from '../../modules/invoices/pendingInvoices/index';
import LongOpenClients from '../../modules/longOpenClients/index';
import ViewRazorPay from '../razorPay/viewRazorPay';
import SuperAdminMatrix from '../../modules/manageperm/superAdminMatrix';
import SuperAdminEngagementLetter from '../superAdminEngagementLetters/index';
import AuditServices from '../../modules/auditservices/create';
import AuditOpenservices from '../../modules/auditservices/auditopenservices/index';
import AuditCRCOpenService from '../../modules/auditservices/auditITeCcrcopenservices/index';
import AuditAMOpenservices from '../../modules/auditservices/auditITeCAMopenservices/index';
import AuditOpenServiceEM from '../../modules/auditservices/auditopenservice(em)/index';
import AuditCorpClientOpenService from '../../modules/auditservices/auditcorpclientopenservices/index';
import AuditOtherOpenService from '../../modules/auditservices/auditITeCothersopenservices/index';
import EngagementLetter from '../../modules/engagementletterforsign/index';
import CpsCheckList from '../../modules/auditservices/cpsCheckList/index1';
import OpenItec from '../../modules/services/view/OpenItec';

import AuditAddAdditional from '../../modules/auditChecklist/checklistGenerator/generateCpsChecklist/auditAdditionalQuestions';
import AuditHome from '../../modules/auditChecklist/checklistGenerator';
import TrialBalanceSheet from '../../modules/auditChecklist/checklistGenerator/trialBalance/trialBalanceSheet';

import IdleTimeOutModal from '../../components/modal/IdleModal';
import RaiseTicket from '../../modules/support/raiseTicket';
import SupportOpen from '../../modules/support/supportOpen';
import SupportInprogress from '../../modules/support/supportInprogress';
import SupportCompleted from '../../modules/support/supportCompleted';
import TicketList from '../../modules/support/ticketList';
import TicketStatus from '../../modules/support/ticketStatus';
import DeleteEmp from '../../modules/core/deleteEmployee';
import token from '../../config/token';
import axios from 'axios';
import { CommonConfig } from '../../config/common-config';
import Policy from '../../components/table/policy';
import TermsConditionInner from '../../components/table/termsConditionInner';
import Logo from '../../assets/Login_logo.png';
import { userType } from '../../config/usertypeValue';
import IMCDraftList from '../../modules/draftDocument/imcDraftList';
import IMCDraftListClient from '../../modules/draftDocument/imcDraftListClient';
import Noofopenservices from '../../modules/services/view/IMCTable/Noofopenservices';
import ClosedServiceItec from '../../modules/services/view/ClosedService/closedservicesItec';
import Noofcloseservices from '../../modules/services/view/ClosedService/Noofclosedservices';
// import Noofinvoices from '../../modules/invoices/SuperAdmin/view/IMCTable/Noofinvoices';
import OpenServiceAll from '../../modules/services/view/OpenService/openservicesall';
import Noofcoreemps from '../../modules/core/view/IMCTable/Noofcoreemps';
import CoreEmployeesITeC from '../../modules/core/view/IMCTable/coreemployeesitec';
import NoofIndividualClients from '../../modules/ultimate/view/IMCTable/noofindividualclients';
import IndividualClientsITeC from '../../modules/ultimate/view/IMCTable/individualclientsitec';
import CorporateClientsITeC from '../../modules/ultimate/view/IMCTable/corporateclientsitec';
import NoofCorporatesClients from '../../modules/ultimate/view/IMCTable/noofcorporateclients';
import ViewGeneratedInvoiceITeC from '../../modules/invoices/SuperAdmin/view/IMCTable/noofinvoicesitec';
import NoofPendingInvoices from '../../modules/invoices/pendingInvoices/IMCTable/noofpendinginvoices';
import NoofPaymentHistory from '../../modules/payments/view/IMCTable/noofpaymenthistory';
import NoofColleagueClients from '../../modules/ultimate/view/IMCTable/noofcolleagueclients';
import ColleagueClientsITeC from '../../modules/ultimate/view/IMCTable/colleagueclientsitec';
// import PreEngagementDocument from '../../modules/auditChecklist/checklistGenerator/preEngagementDocument';
// import AssignEngLetter from '../../modules/auditChecklist/checklistGenerator/assignEngagementLetter';
// import CpsChecklistGenerator from '../../modules/auditChecklist/checklistGenerator/generateCpsChecklist/accordin';
import AddGenericInvoice from '../../modules/EmInvoice/addGenericInvoice';
import { cacheservice } from '../../config/cacheservice';
import ItecService from '../../modules/support/itecService';
import AssignItecEmp from '../../modules/itec/assignitecemp';
import AssignService from '../../modules/itec/assignservice';
import AssignTickets from '../../modules/itec/assigntickets';
import DeleteItecEmp from '../../modules/itec/view/deleteItecEmp';
import DeleteCoreEmp from '../../modules/core/deleteEmployee/deleteCoreEmp';
import MyTicketSupportTiles from '../../components/supportCardTiles/myTicketSupportTiles';
import CreateServicesTiles from '../../components/services/createService';
import GenerateInvoices from '../../components/invoices/generateInvoiceTiles';
import MyInvoices from '../../components/invoices/myInvoiceTiles';
import Leads from '../leads';

export default function Menubar(props) {
    const location = useLocation();
    const classes = useStyles();
    const theme = useTheme();
    const history = useHistory();
    const tokens = token();
    const [open, setOpen] = React.useState(true);
    const [opensubmenu, setSubmenu] = React.useState({});
    const [breadCrumbLabel, setBreadCrumbLabel] = React.useState('Dashboard');
    const [breadCrumbPath, setBreadCrumbPath] = React.useState();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [showResetPassword, setShowResetPassword] = React.useState(false);
    const [IMCLogo, setIMCLogo] = useState('');

    const username = JSON.parse(sessionStorage.getItem('user'));
    const menuContents = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const roleId = menuContents.result && menuContents.result.data.features[0].roleId;

    // const { userName } = username.result.data;
    const { userType } = username.result.data;
    const loggedInName = menuContents && menuContents.result && menuContents.result.data && menuContents.result.data.firstName;
    const [time, setTime] = React.useState();
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const dbname = tennantDetails && tennantDetails.tennantName;
    const [ticketArr, setTicketArr] = React.useState([]);
    const [showDialogBox, setShowDialogBox] = React.useState(false);
    const [showDialogBoxTerms, setshowDialogBoxTerms] = React.useState(false);

    const openInNewTabMain = () => {
        window.open('https://www.advithitec.in/', '_blank');
    };

    const handlePolicy = () => {
        setShowDialogBox(true);
    };
    const handlePolicyClose = () => {
        setShowDialogBox(false);
    };
    const handleTerms = () => {
        setshowDialogBoxTerms(true);
    };
    const handleTermsClose = () => {
        setshowDialogBoxTerms(false);
    };

    const handleDrawerOpen = () => {
        // cacheservice.sendSupportFlag(true);
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    // const handleClickView = (val) => {
    //     // console.log('valueOfVal', val);
    //     if(val === 'View Tickets') {
    //         navigateToIMCSupportTrue();
    //     }
    //     else {
    //         navigateToIMCSupportFalse();
    //     }
    // }

    // const navigateToIMCSupportTrue = () =>{
    //     cacheservice.sendSupportFlag(true);
    // }
    // const navigateToIMCSupportFalse = () =>{
    //     cacheservice.sendSupportFlag(false);
    // }

    const handleToggle = (e) => {
        const menuLabel = e.currentTarget.dataset.menutext;
        setSubmenu({ [menuLabel]: !opensubmenu[menuLabel] });
    };

    const resetPassword = () => {
        // setShowResetPassword(true);
        history.push('/reset');
    };

    const handlePopover = (event) => {
        if (anchorEl == null) {
            setAnchorEl(event.currentTarget);
        } else {
            setAnchorEl(null);
        }
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };
    const openPop = Boolean(anchorEl);
    const id = openPop ? 'simple-popover' : undefined;

    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        setBreadCrumbLabel('Dashboard');
        setBreadCrumbPath('/menu');
        //console.log('menuContents', menuContents);
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/get-imc-logo/${dbname}`)
            .then((response) => {
                // //console.log("logorespoonse", response)
                setIMCLogo(response.config.url);
            })
            .catch((err) => {});
    });

    // const historyTabView = () => {
    //     if(userType.historyStageId === 10){
    //         userType.value = "EM Confirmed";

    //     }
    // }

    const handleOnIdle = (event) => {
        //console.log('user is idle', event);
        //console.log('last active', getLastActiveTime());
        inactivityTime(true);
        setShowModal(true);
    };

    // window.onload = function () {
    //     inactivityTime();
    // }

    const handleOnActive = (event) => {
        //console.log('user is active', event);
        //console.log('time remaining', getRemainingTime());
    };

    const handleOnAction = (event) => {
        //console.log('user did something', event)
    };

    const inactivityTime = function (flag) {
        if (flag) {
            setTime(setTimeout(logout, 1000 * 60));
            function logout() {
                handleLogout();
                setTimeout(() => {
                    clearInterval(time);
                }, 100);
            }
        } else {
            clearInterval(time);
        }
    };

    const { getRemainingTime, getLastActiveTime } = useIdleTimer({
        timeout: 1000 * 60 * 30,
        onIdle: handleOnIdle,
        onActive: handleOnActive,
        onAction: handleOnAction,
        debounce: 500,
    });

    const handleClose = () => {
        //console.log('close');
        setShowModal(false);
        inactivityTime(false);
    };

    const handleLogout = () => {
        history.push('/');
        localStorage.clear();
        sessionStorage.clear();
    };

    const signout = () => {
        history.push('/');
    };

    const IconArrq = [
        {
            icon: faWrench,
            text: 'Manage permission',
            issublist: true,
            sublist: [
                {
                    subText: 'Super Admin Matrix',
                    subPath: '/menu/SuperAdminRoleMatrix',
                },
                { subText: 'Individual Matrix', subPath: '/menu/IndividualRoleMatrix' },
            ],
        },
        { icon: faLandmark, text: 'Bank Details', path: '/menu/bankclients' },
        { icon: faLandmark, text: 'Admin Bank Details', path: '/menu/adminbankdetails' },

        {
            icon: faUserPlus,
            text: 'Create employee & assign Team',
            path: '/menu/CoreView',
        },
        { icon: faPlus, text: 'Service list updation' },
        {
            icon: faWrench,
            text: 'Services',
            issublist: true,
            sublist: [
                { subText: 'Create service', subPath: '/menu/service' },
                { subText: 'Open service', subPath: '/menu/openservice' },
                { subText: 'Closed service', subPath: '/menu/closedservice' },
            ],
        },
        {
            icon: faFileAlt,
            text: 'Invoices',
            issublist: true,
            sublist: [
                {
                    subText: 'ITeC service invoice',
                    subPath: '/menu/itecservice-invoice',
                },
                { subText: 'Generate Invoice for IMC', subPath: '/menu/imcInvoice' },
            ],
        },
        { icon: faWallet, text: 'View payments', path: '/menu/adminpayments' },
        { icon: faFileAlt, text: 'Pending Invoices', path: '/menu/pending-invoices' },
        {
            icon: faUser,
            text: 'Client',
            issublist: true,
            sublist: [
                { subText: 'Individual', subPath: '/menu/ClientIndividualView' },
                { subText: 'Corporate', subPath: '/menu/ClientCorporateView' },
                { subText: 'Colleage', subPath: '/menu/ClientColleagueView' },
            ],
        },

        { icon: faUser, text: 'Create ITeC employee', path: '/menu/itechView' },
        {
            icon: faHandHolding,
            text: 'Support',
            issublist: true,
            sublist: [
                { subText: 'My Ticket', subPath: '/menu/support-ticketlist' },
                // { subText: 'Corporate', subPath: '/menu/ClientCorporateView' },
                // { subText: 'Colleage', subPath: '/menu/ClientColleagueView' },
            ],
        },
    ];
    const icons = [
        faUser,
        faWrench,
        faHandshake,
        faHandshake,
        faUser,
        faWrench,
        faFileAlt,
        faWallet,
        faMale,
        faFileAlt,
        faHandHolding,
        faBell,
        faAngleDown,
        faSignOutAlt,
        faLockOpen,
        faUser,
        faBell,
        faAngleDown,
        faSignOutAlt,
        faLockOpen,
        faFileAlt,
    ];
    const [IconArr, setIconArr] = useState(IconArrq);
    useMemo(() => {
        // console.log("menuContents", menuContents);
        const dynamicMenu =
            menuContents.result &&
            menuContents.result.data.features.map((feature, index) => {
                return {
                    icon: icons[index],
                    text: feature.featureText,
                    issublist: feature.featureFlag,
                    sublist: feature.subFeatures.map((subFeatures) => {
                        if (subFeatures.isActive) {
                            return {
                                subText: subFeatures.subFeatureText,
                                subPath: subFeatures.path,
                                isActive: subFeatures.isActive,
                            };
                        }
                        return {
                            isActive: '',
                        };
                    }),
                };
            });

        setIconArr(dynamicMenu);
    }, [menuContents]);
    if (showResetPassword) {
        return <ResetPassword />;
    }

    return (
        <>
            <div className={classes.root}>
                <div className={classes.root1}>
                    <CssBaseline />
                    <AppBar
                        position="fixed"
                        className={clsx(classes.appBar, {
                            [classes.appBarShift]: open,
                        })}
                    >
                        <Toolbar className={classes.headermain}>
                            <div className={classes.headerleft}>
                                <IconButton
                                    color="inherit"
                                    aria-label="open drawer"
                                    onClick={handleDrawerOpen}
                                    edge="start"
                                    className={clsx(classes.menuButton, {
                                        [classes.hide]: open,
                                    })}
                                >
                                    <MenuIcon />
                                </IconButton>
                            </div>
                            <div className={classes.headerright}>
                                <div className={classes.headericon}>
                                    <div>
                                        <Notification />
                                    </div>
                                </div>
                                <div className={classes.headericon1}>
                                    <FontAwesomeIcon style={{ color: '#72C68D' }} icon={faUser} />
                                </div>

                                <span style={{ color: 'hsl(0deg 0% 49%)', marginRight: '7px' }}>Hello,</span>
                                <span style={{ marginRight: '11px' }}>{loggedInName}</span>
                                <div
                                    role="button"
                                    tabIndex="0"
                                    className={classes.welcomeblock}
                                    onClick={handlePopover}
                                    onKeyDown={handlePopover}
                                >
                                    <span style={{ marginLeft: '4px' }} role="button" tabIndex={0} className="logoutbtn">
                                        <FontAwesomeIcon icon={faAngleDown} />
                                    </span>
                                    <Popover
                                        id={id}
                                        open={openPop}
                                        anchorEl={anchorEl}
                                        onClose={handlePopoverClose}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'center',
                                        }}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'center',
                                        }}
                                    >
                                        <div className={classes.logoutPopover}>
                                            <div>
                                                <Button size="small" className={classes.signOutBtn} onClick={resetPassword}>
                                                    Reset Password
                                                </Button>
                                            </div>
                                            <div>
                                                <Button size="small" className={classes.signOutBtn} onClick={signout}>
                                                    Signout
                                                </Button>
                                            </div>
                                        </div>
                                    </Popover>
                                </div>
                            </div>
                        </Toolbar>
                    </AppBar>
                    <Drawer
                        className={classes.drawer}
                        variant="persistent"
                        anchor="left"
                        open={open}
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                    >
                        <div className={classes.toolbar}>
                            <div className={classes.headerImg}>
                                <img className={classes.clientlogo} src={IMCLogo} alt="logo" />
                            </div>
                            <div style={{ marginRight: '10px' }}>
                                <IconButton onClick={handleDrawerClose}>
                                    {theme.direction === 'rtl' ? <ChevronRightIcon /> : <MenuIcon />}
                                </IconButton>
                            </div>
                        </div>
                        <List>
                            <div>
                                {IconArr &&
                                    IconArr.map((data) =>
                                        data.issublist ? (
                                            <div className={classes.menuList}>
                                                <ListItem className={classes.iconmainlist} data-menutext={data.text} onClick={handleToggle}>
                                                    <ListItemIcon className={classes.iconlist}>
                                                        <FontAwesomeIcon icon={data.icon} />
                                                    </ListItemIcon>
                                                    <ListItemText
                                                        className={classes.listitemtext}
                                                        classes={{ primary: classes.gettext }}
                                                        primary={data.text}
                                                    />
                                                    {opensubmenu[data.text] ? (
                                                        <div className={classes.menutoggleicon}>-</div>
                                                    ) : (
                                                        <div className={classes.menutoggleicon}>+</div>
                                                    )}
                                                </ListItem>
                                                <Collapse in={opensubmenu[data.text]} timeout="auto" unmountOnExit>
                                                    <List component="div" disablePadding>
                                                        {data.sublist.map((submenulist) => {
                                                            return (
                                                                <>
                                                                    {submenulist.isActive ? (
                                                                        <ListItem
                                                                            button
                                                                            key={submenulist.subText}
                                                                            activeClassName="is-active"
                                                                            className={classes.nested}
                                                                            component={Link}
                                                                            to={
                                                                                userType === 'ADMIN' &&
                                                                                roleId === 10 &&
                                                                                submenulist.subPath === '/menu/support-ticketstatus'
                                                                                    ? '/menu/view-tickets'
                                                                                    : submenulist.subPath
                                                                            }
                                                                            onClick={handleDrawerClose}
                                                                        >
                                                                            <div>
                                                                                <ListItemText
                                                                                    classes={{ primary: classes.gettext }}
                                                                                    primary={submenulist.subText}
                                                                                    // onClick={() => handleClickView(submenulist.subText)}
                                                                                />
                                                                            </div>
                                                                        </ListItem>
                                                                    ) : (
                                                                        <div style={{ display: 'none' }} />
                                                                    )}
                                                                </>
                                                            );
                                                        })}
                                                    </List>
                                                </Collapse>
                                                <div className={classes.divider} />
                                            </div>
                                        ) : (
                                            <>
                                                <div style={{ display: 'none' }} />
                                            </>
                                        )
                                    )}
                            </div>
                        </List>
                        <div className={classes.menuList}>
                            <ListItem className={classes.iconmainlist} data-menutext="Leads" component={Link} to="/menu/leads">
                                <ListItemIcon className={classes.iconlist}>
                                    <FontAwesomeIcon icon={faUser} />
                                </ListItemIcon>
                                <ListItemText className={classes.listitemtext} classes={{ primary: classes.gettext }} primary="Leads" />
                            </ListItem>
                        </div>
                        <div className={classes.mainfooter}>
                            <div className={classes.divider} />
                            <div className="btmLogo ptb10">
                                <img src={Logo} alt="logo" className={classes.logo} onClick={openInNewTabMain} />
                            </div>
                            <div className={classes.footercontent}>&#169; Copyright 2021 Advith ITeC</div>
                            <div className="btmPolicy">
                                <ul>
                                    <li onClick={handlePolicy}>Privacy Policy</li>
                                    <li onClick={handleTerms}>Terms and Condition</li>
                                </ul>
                            </div>
                            {/* <div className={classes.footercontent}>
                                <Button
                                    color="primary"
                                    size="small"
                                    className={classes.button}
                                    // startIcon={<InsertCommentIcon />}
                                    onClick={() => handlePolicy()}
                                >
                                    Privacy Policy
                                </Button>
                                <Button
                                    color="primary"
                                    size="small"
                                    className={classes.button}
                                    // startIcon={<InsertCommentIcon />}
                                    onClick={() => handleTerms()}
                                >
                                    Terms and Condition
                                </Button>
                            </div> */}
                        </div>
                    </Drawer>
                    <main
                        className={clsx(classes.content, {
                            [classes.contentShift]: open,
                        })}
                    >
                        <div>
                            <div className={classes.toolbar} />
                            {/* <Grid item xs={12}>
                                <CustomBreadcrumbs breadCrumbLabel={breadCrumbLabel} breadCrumbPath={breadCrumbPath} />
                            </Grid> */}
                            <ScrollToTop>
                                <Switch>
                                    <Route exact path="/menu" component={Dashboard} />
                                    <Route path="/menu/IMCView" component={IMCView} />
                                    <Route path="/menu/imc" component={Intermediary} />
                                    <Route path="/menu/updateimc" component={UpdateImc} />
                                    <Route path="/menu/service" component={Services} />
                                    <Route path="/menu/openservice" component={OpenService} />
                                    <Route path="/menu/closedservice" component={ClosedService} />
                                    <Route path="/menu/manageperm" component={ManagePerm} />
                                    <Route path="/menu/SuperAdminRoleMatrix" component={SuperAdminRoleMatrix} />
                                    <Route path="/menu/IndividualRoleMatrix" component={IndividualRoleMatrix} />
                                    <Route path="/menu/CoreView" component={CoreView} />
                                    <Route path="/menu/core" component={Core} />
                                    <Route path="/menu/updatecore" component={UpdateCore} />
                                    <Route path="/menu/ClientIndividualView" component={ClientIndividualView} />
                                    <Route path="/menu/ClientCorporateView" component={ClientCorporateView} />
                                    <Route path="/menu/ClientIndividualCreate" component={ClientIndividualCreate} />
                                    <Route path="/menu/ClientCorporateCreate" component={ClientCorporateCreate} />
                                    <Route path="/menu/ClientColleagueView" component={ClientColleagueView} />
                                    <Route path="/menu/ClientColleagueCreate" component={ClientColleagueCreate} />
                                    <Route path="/menu/updateindividual" component={UpdateIndividual} />
                                    <Route path="/menu/updatecorporate" component={UpdateCorporate} />
                                    <Route path="/menu/updatecolleague" component={UpdateColleague} />
                                    <Route path="/menu/itecservice-invoice" component={ItecInvoice} />
                                    <Route path="/menu/payment-invoice" component={InvoicePayment} />
                                    <Route path="/menu/adminpayments" component={AdminPayments} />
                                    <Route path="/menu/adminpaymenthistory" component={AdminPaymentHistory} />
                                    <Route path="/menu/superadminpayments" component={NoofPaymentHistory} />
                                    <Route path="/menu/paymenthistory" component={IndividualPaymentHistory} />
                                    <Route path="/menu/corporatepaymmenthistory" component={CorporatePaymmentHistory} />
                                    <Route path="/menu/itec" component={Itec} />
                                    <Route path="/menu/itechView" component={ItechView} />
                                    <Route path="/menu/updateitec" component={UpdateItec} />
                                    <Route path="/menu/bankclients" component={BankClients} />
                                    <Route path="/menu/editbankdetails" component={EditBankDetails} />
                                    <Route path="/menu/adminedit-bankdetails" component={AdminEditBankDetails} />
                                    <Route path="/menu/updateservice" component={UpdateServices} />
                                    <Route path="/menu/imcInvoice" component={ImcInvoices} />
                                    <Route path="/menu/taxInvoice" component={TaxInvoice} />
                                    <Route path="/menu/updateInvoice" component={UpdateInvoice} />
                                    <Route path="/menu/indInvoice" component={AdminIndInvoice} />
                                    <Route path="/menu/updateIndInvoice" component={UpdateIndInvoice} />
                                    <Route path="/menu/corpInvoice" component={AdminCorpInvoice} />
                                    <Route path="/menu/taxInvoiceInd" component={TaxInvoiceInd} />
                                    <Route path="/menu/adminbankdetails" component={AdminBankDetails} />
                                    <Route path="/menu/ultimate-invoice" component={UltimateInvoiceView} />
                                    <Route path="/menu/MyInvoices" component={UltimateInvoice} />
                                    <Route path="/menu/genInvoices" component={ViewGeneratedInvoice} />
                                    <Route path="/menu/checkListGenerator" component={CheckListGenerator} />
                                    <Route path="/menu/incorporationFlow" component={IncorporationFlow} />
                                    <Route path="/coredashboard" component={CoreEMDashboard} />
                                    <Route path="/menu/clientchecklist-generator" component={ClientCheckListGenetator} />
                                    <Route path="/menu/clientbank-generator" component={ClientBankDetailsGenerator} />
                                    <Route path="/menu/incometaxpassword" component={ClientIncomeTaxPassword} />
                                    <Route path="/menu/clienttraveloutsideindia" component={ClientTravelOutsideIndia} />
                                    <Route path="/menu/directorincompany" component={DirectorInCompany} />
                                    <Route path="/menu/clienttotalincome" component={ClientTotalIncome} />
                                    <Route path="/menu/addAdditional" component={AddAdditional} />
                                    <Route path="/menu/differentsource" component={DifferentSource} />
                                    <Route path="/menu/clientforeignassets" component={ClientForeignAssets} />
                                    <Route path="/menu/checkListUltimate" component={ClientChecklistHome} />

                                    <Route path="/menu/detail-analysis" component={DetailAnalysis} />
                                    <Route path="/menu/detailAnalysisCore" component={DetailAnalysisCore} />
                                    <Route path="/menu/itec-openservice" component={ItecOpenService} />
                                    <Route path="/menu/itech-itr-checklist" component={ItechCheckList} />
                                    <Route path="/menu/itech-bankdetails" component={ItechBankDetails} />
                                    <Route path="/menu/itec-openserviceAM" component={ItecOpenServiceAM} />
                                    <Route path="/menu/crc-checklist" component={CrcCheckList} />
                                    <Route path="/menu/client-addquestion" component={ClientAddAdditional} />
                                    <Route path="/menu/imc-draft-document" component={IMCDraftList} />
                                    <Route path="/menu/imc-add-draft" component={IMCDraftDocument} />
                                    <Route path="/menu/client-draft-document" component={IMCDraftListClient} />
                                    <Route path="/menu/imc-add-draft-client" component={ClientDraftDocument} />
                                    <Route path="/menu/imc-tax-payment" component={IMCFinalDocument} />
                                    <Route path="/menu/imc-final-doc-approval" component={IMCFinalDocApproval} />
                                    <Route path="/menu/client-tax-payment" component={ClientFinalDocument} />
                                    <Route path="/menu/client-final-doc-approval" component={ClientFinalDocApproval} />
                                    <Route path="/menu/imc-reports" component={IMCReports} />
                                    <Route path="/menu/request-invoice" component={RequestInvoice} />
                                    <Route path="/menu/itec-detail-analysis-crc" component={ItecDetailAnalysisCRC} />
                                    <Route path="/menu/itec-detail-analysis-am" component={ItecDetailAnalysisAM} />

                                    <Route path="/menu/ultimate-openservice" component={UltimateOpenService} />
                                    <Route path="/menu/rename-team" component={Rename} />
                                    <Route path="/menu/pending-invoices" component={NoofPendingInvoices} />
                                    <Route path="/menu/long-open-clients" component={LongOpenClients} />
                                    <Route path="/menu/view-razorpay" component={ViewRazorPay} />
                                    <Route path="/menu/super-admin-matrix" component={SuperAdminMatrix} />
                                    <Route path="/menu/super-admin-engagement-letters" component={SuperAdminEngagementLetter} />
                                    <Route path="/menu/audit-service" component={AuditServices} />
                                    <Route path="/menu/audit-openservice" component={AuditOpenservices} />
                                    <Route path="/menu/audit-crcopenservice" component={AuditCRCOpenService} />
                                    <Route path="/menu/audit-openserviceem" component={AuditOpenServiceEM} />
                                    <Route path="/menu/audit-openservicecorp" component={AuditCorpClientOpenService} />
                                    <Route path="/menu/audit-openserviceam" component={AuditAMOpenservices} />
                                    <Route path="/menu/audit-openserviceothers" component={AuditOtherOpenService} />
                                    <Route path="/menu/audit-engagementletterforsign" component={EngagementLetter} />
                                    <Route path="/menu/createCpsChecklist" component={CpsCheckList} />

                                    <Route path="/menu/audit-add-additional-question" component={AuditAddAdditional} />
                                    <Route path="/menu/audit" component={AuditHome} />
                                    <Route path="/menu/raise-ticket" component={RaiseTicket} />
                                    <Route path="/menu/support-open" component={SupportOpen} />
                                    <Route path="/menu/support-inprogress" component={SupportInprogress} />
                                    <Route path="/menu/support-completed" component={SupportCompleted} />
                                    <Route path="/menu/support-ticketlist" component={TicketList} />
                                    <Route path="/menu/support-ticketstatus" component={ItecService} />
                                    <Route path="/menu/deleteEmp" component={DeleteEmp} />
                                    <Route path="/menu/trialBalanceSheet" component={TrialBalanceSheet} />
                                    <Route path="/menu/policy" component={Policy} />
                                    <Route path="/menu/terms-condition" component={TermsConditionInner} />
                                    <Route path="/menu/open-itec" component={OpenItec} />
                                    <Route path="/menu/noofopenservices" component={Noofopenservices} />
                                    <Route path="/menu/closedserviceitec" component={ClosedServiceItec} />
                                    <Route path="/menu/noofcloseservices" component={Noofcloseservices} />
                                    {/* <Route path="/menu/noofinvoices" component={Noofinvoices} /> */}
                                    <Route path="/menu/openserviceall" component={OpenServiceAll} />
                                    <Route path="/menu/noofcoreemps" component={Noofcoreemps} />
                                    <Route path="/menu/coreemployeesitec" component={CoreEmployeesITeC} />
                                    <Route path="/menu/noofindividualclients" component={NoofIndividualClients} />
                                    <Route path="/menu/individualclientsitec" component={IndividualClientsITeC} />
                                    <Route path="/menu/noofcorporatesclients" component={NoofCorporatesClients} />
                                    <Route path="/menu/corporateclientsitec" component={CorporateClientsITeC} />
                                    <Route path="/menu/viewgeneratedinvoiceitec" component={ViewGeneratedInvoiceITeC} />
                                    <Route path="/menu/noofpendinginvoices" component={PendingInvoices} />
                                    <Route path="/menu/noofpaymenthistory" component={SuperAdminPayments} />
                                    <Route path="/menu/noofcolleagueclients" component={NoofColleagueClients} />
                                    <Route path="/menu/colleagueclientsitec" component={ColleagueClientsITeC} />
                                    <Route path="/menu/Invoices" component={EMInvoice} />
                                    <Route path="/menu/add-invoices" component={AddGenericInvoice} />
                                    <Route path="/menu/view-invoices" component={ViewInvoices} />
                                    <Route path="/menu/view-tickets" component={TicketStatus} />
                                    <Route path="/menu/imc-itec-emp" component={AssignItecEmp} />
                                    <Route path="/menu/assign-services" component={AssignService} />
                                    <Route path="/menu/assign-tickets" component={AssignTickets} />
                                    <Route path="/menu/delete-employee" component={DeleteItecEmp} />
                                    <Route path="/menu/delete-core-employee" component={DeleteCoreEmp} />
                                    <Route path="/menu/myticket-list" component={MyTicketSupportTiles} />
                                    <Route path="/menu/createServiceTile" component={CreateServicesTiles} />
                                    <Route path="/menu/generateInvoicesTile" component={GenerateInvoices} />
                                    <Route path="/menu/myInvoicesTile" component={MyInvoices} />
                                    <Route path="/menu/leads" component={Leads} />
                                    <Redirect from="/menu/" to="/menu/PreEngagementDocument" />
                                    <Route path="/menu/:page?" render={(props) => <AuditHome {...props} />} />

                                    <Redirect from="/menu/" to="/menu/AssignEngLetter" />
                                    <Route path="/menu/:page?" render={(props) => <AuditHome {...props} />} />

                                    <Redirect from="/menu/" to="/menu/CpsChecklistGenerator" />
                                    <Route path="/menu/:page?" render={(props) => <AuditHome {...props} />} />

                                    <Redirect from="/menu/" to="/menu/CaroChecklist" />
                                    <Route path="/menu/:page?" render={(props) => <AuditHome {...props} />} />

                                    <Redirect from="/menu/" to="/menu/AuditChecklist" />
                                    <Route path="/menu/:page?" render={(props) => <AuditHome {...props} />} />

                                    <Redirect from="/menu/" to="/menu/TaxAuditProcessChecklist" />
                                    <Route path="/menu/:page?" render={(props) => <AuditHome {...props} />} />

                                    <Redirect from="/menu/" to="/menu/TrialBalance" />
                                    <Route path="/menu/:page?" render={(props) => <AuditHome {...props} />} />
                                </Switch>
                            </ScrollToTop>
                            <IdleTimeOutModal showModal={showModal} handleClose={handleClose} handleLogout={handleLogout} />
                        </div>
                    </main>
                </div>
            </div>
            {showDialogBox && <Policy showDialogBox={showDialogBox} handlePolicyClose={handlePolicyClose} />}
            {showDialogBoxTerms && <TermsConditionInner showDialogBoxTerms={showDialogBoxTerms} handleTermsClose={handleTermsClose} />}
        </>
    );
}
